import { Grid, Typography } from '@mui/material';
import { FormikHelpers } from 'formik';
import Layout from '../../../core/ui/layout/Layout';
import { useSendApiData } from '../../../core/hooks/useSendApiData';
import { toastError, toastMessage } from '../../../core/utils/ui/alert';
import { parseValidationErrors } from '../../../core/utils/validation';
import { PublicationCreate } from '../publication';
import CreatePublicationForm from '../components/CreatePublicationForm';
import ReturnButton from '../../../core/ui/utility/ReturnButton';
import { parseFormQuery } from '../../../core/utils/utility';

const CreatePublicationContainer = () => {
  const { callApi, loading: submitting } = useSendApiData();

  const handleSubmit = async (
    values: PublicationCreate,
    { setFieldError }: FormikHelpers<PublicationCreate>
  ) => {
    let success = false;

    const formData: any = parseFormQuery(values, []);
    formData.set('other', values.other ? 1 : 0);

    await callApi({
      endpoint: 'auth-phe24/publications',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onValidationError: (err) => parseValidationErrors(err, setFieldError),
      onError: toastError,
      onSuccess: async (_) => {
        toastMessage('Publication Created');
        success = true;
      },
    });

    return success;
  };

  return (
    <Layout renderLeftToolbar={() => <ReturnButton to="/publications" />}>
      <Grid sx={{ p: 2 }}>
        <Grid container sx={{ mb: 2, px: 1 }}>
          <Typography variant="h5">Add Publication</Typography>
        </Grid>
        <CreatePublicationForm
          onSubmit={handleSubmit}
          submitting={submitting}
        />
      </Grid>
    </Layout>
  );
};

export default CreatePublicationContainer;
